import { SHOW_CONFIRM } from 'constants/modal';

/**
 * @param {{
 * options: {},
 * type: string,
 * title: string,
 * caption: string,
 * onCancel: Function,
 * onConfirm: Function,
 * }} param
 */
function showConfirm({
  type,
  title,
  caption,
  options,
  onCancel,
  onConfirm,
  checkCaption,
}) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      payload: {
        type,
        title,
        options,
        caption,
        onCancel,
        onConfirm,
        checkCaption,
      },
      type: SHOW_CONFIRM,
    };
    dispatch(action);
  };
}

export default showConfirm;
